import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const appName = process.env.REACT_APP_NAME || 'UltraCoder IDE';
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'support@ultracoder.dev';
  const websiteUrl = process.env.REACT_APP_WEBSITE_URL || '#';
  const githubUrl = process.env.REACT_APP_GITHUB_URL || '#';
  const docsUrl = process.env.REACT_APP_DOCS_URL || '#';

  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
    setForm({ name: '', email: '', message: '' });
  };

  const links = [
    { icon: '🌐', label: 'Website', url: websiteUrl, desc: 'Visit our official website' },
    { icon: '📖', label: 'Documentation', url: docsUrl, desc: 'Explore detailed guides and API references' },
    { icon: '🐙', label: 'GitHub', url: githubUrl, desc: 'Browse source code and contribute' },
    { icon: '✉️', label: 'Email', url: `mailto:${supportEmail}`, desc: supportEmail },
  ];

  return (
    <section className="contact" id="contact">
      <div className="contact__container">
        <div className="contact__header">
          <div className="contact__badge">📬 Get In Touch</div>
          <h2 className="contact__title">
            Ready to supercharge <br />
            <span className="contact__title-gradient">your development?</span>
          </h2>
          <p className="contact__subtitle">
            Have questions about {appName}? Want to report a bug, request a feature, or just say hi?
            We'd love to hear from you.
          </p>
        </div>

        <div className="contact__layout">
          {/* Links */}
          <div className="contact__links">
            <h3 className="contact__links-title">Connect with us</h3>
            {links.map((link, i) => (
              <a key={i} href={link.url} target="_blank" rel="noreferrer" className="contact__link-card">
                <span className="contact__link-icon">{link.icon}</span>
                <div className="contact__link-info">
                  <strong>{link.label}</strong>
                  <span>{link.desc}</span>
                </div>
                <svg className="contact__link-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </a>
            ))}
          </div>

          {/* Form */}
          <div className="contact__form-wrapper">
            {submitted ? (
              <div className="contact__success">
                <div className="contact__success-icon">✅</div>
                <h3>Message sent!</h3>
                <p>Thank you for reaching out. We'll get back to you within 24 hours.</p>
              </div>
            ) : (
              <form className="contact__form" onSubmit={handleSubmit}>
                <h3 className="contact__form-title">Send us a message</h3>
                <div className="contact__form-group">
                  <label htmlFor="name">Your Name</label>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="John Doe"
                    required
                  />
                </div>
                <div className="contact__form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="john@example.com"
                    required
                  />
                </div>
                <div className="contact__form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Tell us how we can help you..."
                    rows={5}
                    required
                  />
                </div>
                <button type="submit" className="contact__submit">
                  <span>Send Message</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/>
                  </svg>
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;